import * as v from "react";
import { i as h, E as u, x as c, r as f, c as b } from "../createReactComponent-58f9bea8.mjs";
import { e as d } from "../class-map-2994e95e.mjs";
import { r as p } from "../state-7560d4dc.mjs";
import { r as w } from "../icon-c572aa57.mjs";
import { a as y } from "../utils-cf5bbdd1.mjs";
import "../property-9daa16cd.mjs";
const k = h`
  :host .toast-container {
    display: flex;
    flex-direction: column;
    gap: calc(var(--exo-spacing-medium) / 2);
    position: fixed;
    top: var(--exo-spacing-x-small);
    right: var(--exo-spacing-standard);
    z-index: var(--exo-z-index-tooltip-popup);
  }

  :host .alert-toast {
    box-sizing: border-box;
    cursor: text;
    font: var(--exo-text-body-medium);
    outline: none;
    text-align: left;
    width: calc(var(--exo-size-1) * 3 + var(--exo-size-1) / 4);
    min-width: calc(var(--exo-size-1) * 3);
    max-width: calc(var(--exo-size-1) * 4 + var(--exo-size-1) / 2);
    min-height: calc(var(--exo-size-1) * 0.6);
    display: flex;
    gap: var(--exo-spacing-x-small);
    align-items: normal;
    box-shadow: var(--exo-spacing-none) var(--exo-spacing-small)
      var(--exo-spacing-x-large) var(--exo-spacing-none)
      var(--exo-color-shadow-strong);
    border-radius: calc(2 * var(--exo-radius-small));
    padding: var(--exo-spacing-small) var(--exo-spacing-x-small)
      var(--exo-spacing-small) var(--exo-spacing-small);
    top: calc(var(--exo-spacing-medium) / 2);
    pointer-events: none;
    z-index: var(--exo-z-index-tooltip-popup);
  }

  :host .alert-toast--information {
    background-color: var(--exo-color-background-brand);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-info-strong);
    color: var(--exo-color-foreground);
  }

  :host .alert-toast--success {
    background-color: var(--exo-color-background-success);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-success-strong);
  }

  :host .alert-toast--warning {
    background-color: var(--exo-color-background-warning);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-warning-strong);
  }

  :host .alert-toast--error {
    background-color: var(--exo-color-background-danger-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-danger-strong);
  }

  :host .alert-toast__icon {
    left: calc(var(--exo-spacing-medium) / 2);
  }

  :host .alert-toast__icon--success {
    color: var(--exo-color-background-success-strong);
  }

  :host .alert-toast__icon--warning {
    color: var(--exo-color-background-warning-strong);
  }

  :host .alert-toast__icon--error {
    color: var(--exo-color-background-danger-strong);
  }

  /* Toast Animation */

  :host .alert-toast.alert-toast--opened {
    animation: toast-slide var(--exo-time-standard) ease forwards;
  }

  @keyframes toast-slide {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  :host .alert-toast.alert-toast--hide {
    animation: toast-hide var(--exo-time-standard) ease-out forwards;
  }

  @keyframes toast-hide {
    from {
      transform: translateX(calc(-1 * var(--exo-spacing-x-small)));
      opacity: 1;
      filter: blur(var(--exo-spacing-none));
    }
    to {
      transform: translateX(var(--exo-spacing-standard));
      opacity: 0;
      filter: blur(var(--exo-spacing-standard));
    }
  }
`;
var C = Object.defineProperty, z = Object.getOwnPropertyDescriptor, x = (s, t, a, o) => {
  for (var e, i = o > 1 ? void 0 : o ? z(t, a) : t, l = s.length - 1; l >= 0; l--)
    (e = s[l]) && (i = (o ? e(t, a, i) : e(i)) || i);
  return o && i && C(t, a, i), i;
}, T = ((s) => (s.INFO = "Information", s.SUCCESS = "Success", s.WARNING = "Warning", s.ERROR = "Error", s))(T || {});
const N = { maxToastsToShow: 3, duration: 5e3 };
class n extends u {
  constructor() {
    super(...arguments), this.toasts = [], this.options = N;
  }
  show(t) {
    const a = y(), o = { ...t, id: a, toBeRemoved: !1, isNew: !0 };
    if (this.toasts = [o, ...this.toasts], this.toasts.length > this.options.maxToastsToShow) {
      const e = this.toasts[this.toasts.length - 1];
      this.dismiss(e == null ? void 0 : e.id);
    }
    return setTimeout(() => {
      this.dismiss(a);
    }, this.options.duration), setTimeout(() => {
      this.toasts = this.toasts.map((e) => e === o ? { ...e, isNew: !1 } : e);
    }, 500), a;
  }
  dismiss(t) {
    const a = this.toasts.find((o) => o.id === t);
    a && (this.toasts = this.toasts.map((o) => o === a ? { ...o, toBeRemoved: !0 } : o), setTimeout(() => {
      this.toasts = this.toasts.filter((o) => o.id !== a.id);
    }, 500));
  }
  setOptions(t) {
    this.options = { ...this.options, ...t };
  }
  render() {
    return c`
      <div class="toast-container">
        ${this.toasts.map((t) => c`<div
              class=${d({ "alert-toast": !0, [`alert-toast--${t.type.toLowerCase()}`]: !0, "alert-toast--opened": t.isNew, "alert-toast--hide": t.toBeRemoved })}
            >
              <ex-icon
                class=${d({ "alert-toast__icon": !0, [`alert-toast__icon--${t.type.toLowerCase()}`]: !0 })}
                size="S"
                icon=${t.type}
              ></ex-icon>
              <div class="description">${t.description}</div>
            </div>`)}
      </div>
    `;
  }
}
n.styles = k, x([p()], n.prototype, "toasts", 2), x([p()], n.prototype, "options", 2);
const m = (s = "") => {
  f("ex-alert-toast", n, s), w();
}, g = class r {
  static initialize() {
    r.toastContainer || (m(), r.toastContainer = document.createElement("ex-alert-toast"), document.body.appendChild(r.toastContainer));
  }
  static setOptions(t) {
    var a;
    r.initialize(), (a = r.toastContainer) == null || a.setOptions(t);
  }
  static show(t) {
    return r.initialize(), r.toastContainer ? r.toastContainer.show(t) : null;
  }
  static dismiss(t) {
    r.toastContainer && r.toastContainer.dismiss(t);
  }
};
g.toastContainer = null;
let X = g;
const B = b({ tagName: "ex-alert-toast", elementClass: n, react: v, events: {}, displayName: "ExAlertToast", registerWebComponent: m });
export {
  T as AlertToastType,
  B as ExAlertToast,
  X as ToastController,
  m as register
};
